'use client';

import { useAgencyRealtime } from '@/hooks/useAgencyRealtime';

export const Bootstrap = ({ children }: { children: React.ReactNode }) => {
  useAgencyRealtime();

  return children;
};
